import {ClipboardEvent} from "react";

/**
 * Handle paste event at cursor position in input field
 *
 * @param e - React clipboard event
 * @param onValueChange - Callback to update the value
 * @returns Object with new value and cursor position
 *
 * @example
 * <input
 *   onPaste={(e) => handlePasteAtCursor(e, setValue)}
 * />
 */
export function handlePasteAtCursor(
    e: ClipboardEvent<HTMLInputElement>,
    onValueChange: (value: string) => void,
): {newValue: string; newCursorPos: number} {
    const input = e.currentTarget;
    const start = input.selectionStart ?? 0;
    const end = input.selectionEnd ?? 0;
    const currentValue = input.value;

    const pastedText = e.clipboardData.getData("text");

    const newValue = currentValue.slice(0, start) + pastedText + currentValue.slice(end);

    e.preventDefault();

    onValueChange(newValue);

    const newCursorPos = start + pastedText.length;

    setTimeout(() => {
        input.setSelectionRange(newCursorPos, newCursorPos);
    }, 0);

    return {newValue, newCursorPos};
}
